import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// Rename the imported component to something different, like BaseContent
import TopLuxSolar from './Top_lux'; 


// Change the function name to match the file's purpose, e.g., SolarPageWrapper
export default function SolarPageWrapper() { 

  return (
    // Render the imported component here
    <TopLuxSolar/> 
  );
}